<template>
    <div class="rest_list_container">
        <button class="order__heading_back_arrow" @click.prevent="clickBackArrow">
            <svg>
                <use xlink:href="/icons/base.svg#back_arrow"></use>
            </svg>
        </button>
        <div class="rest_list__item_rest_name">
            {{ restStopListTitle }}
        </div>
    </div>
    <div class="rest_list_container">
        <div class="rest_list__header">
            <div class="rest_list__header_container">
                <rest_list_header_item
                    v-for="item in selectAggregatorsLocations"
                    :key="'rest_list_header_item_' + item.id"
                    :item="item"
                    :operationName="'stop_list_locations'"
                    @select_item_header="selectItemHeader"
                />
            </div>
        </div>
    </div>
    <div class="rest_list__search">
        <search_block
            :key="'search_block_'"
            :placeholderText="placeholderTextSearch"
            @search_input_data="searchInputData"
        />
    </div>

    <div class="rest_list__scroll">
        <div class="rest_list__scroll_container">
            <rest_list_item
                v-for="item in locationsList"
                :key="'rest_list_item_' + item.id"
                :restItem="item"
                :operationName="'stop_list_locations'"
                @click_switch_item="clickSwitchItem"
            />
        </div>

    </div>
    <div class="rest_list__buttons">
        <div class="rest_list__buttons_container">
            <button class="rest_list__buttons_button_off" @click.prevent="disableStopProducts">
                <spinner_button
                    v-if="isDisableStop"
                    :key="'spinner_button_disable'"
                    :color="colorSpinner"
                    :size="'30px'"
                />
                <div v-else class="rest_list__buttons_button_off_text">
                    {{ __t('O.REMOVE_FROM_STOP') }}
                </div>
            </button>
            <button class="rest_list__buttons_button_on" @click.prevent="enableStopProducts">
                <spinner_button
                    v-if="isEnableStop"
                    :key="'spinner_button_enable'"
                    :color="colorSpinner"
                    :size="'30px'"
                />
                <div v-else class="rest_list__buttons_button_on_text">
                    {{ __t('O.PUT_ON_STOP') }}
                </div>
            </button>
        </div>
    </div>

</template>

<script>

import rest_list_header_item from "../../RestListHeaderItem.vue";
import search_block from "../../SearchBlock.vue";
import rest_list_item from "../../RestListItem.vue";
import {changeBody} from "../../../../mixins/changeBody";
import spinner from "../../../loader/Spinner.vue";
import switch_block from "../../SwitchBlock.vue";
import {createHelpers} from "vuex-map-fields";
import burger_menu from "../../../heading/BurgerMenu.vue";
import {screenSize} from "../../../../mixins/screenSize";
import spinner_button from "../../../loader/SpinnerButton.vue";
import {colorFunctions} from "../../../../mixins/colorFunctions";
import {mouseMoveScroll} from "../../../../mixins/mouseMoveScroll";
import {useToast} from "vue-toastification";
const toast = useToast();

const {mapFields: mOrders} = createHelpers({
    getterType: 'orders/getOrdersField',
    mutationType: 'orders/updateOrdersField',
})
const {mapFields: mStopList} = createHelpers({
    getterType: 'stop_list/getStopListField',
    mutationType: 'stop_list/updateStopListField',
})
const {mapFields: mAggregators} = createHelpers({
    getterType: 'aggregators/getAggregatorsField',
    mutationType: 'aggregators/updateAggregatorsField',
})

export default {
    name: "rest_list",
    props: {
        restId: {
            type: String,
            required: false,
        },

    },
    emits: [],
    mixins: [changeBody, screenSize, colorFunctions, mouseMoveScroll],
    components: {
        spinner_button,
        burger_menu,
        rest_list_header_item,
        search_block,
        rest_list_item,
        spinner,
        switch_block,
    },
    data() {
        return {
            locationsList: [],
            itemHeader: null,
            classScrollElementMouseMove: '.rest_list__header',
            scrollElementMouseMove: null,
            restStopList: null,
            activeAggregator: null,
            isEnableStop: false,
            isDisableStop: false,
            selectAggregatorsLocations:[],
        }
    },
    created() {
        if(this.restId) {
            this.restStopList = this.posRestaurantsList.find(item => item.id === parseInt(this.restId));
            this.selectAggregatorsLocations = this.selectAggregatorsLocationsRest;
        } else {
            this.selectAggregatorsLocations = this.selectAggregatorsLocationsAll;
        }
        if (this.selectAggregatorsLocations.length !== 0) {
            this.clickAggregator();
        }
    },
    beforeMount() {
        EventBus.$on('stop_list_action', this.stopListAction);
    },
    beforeUnmount() {
        EventBus.$off('stop_list_action', this.stopListAction);
    },
    methods: {
        stopListAction(actionName) {
            if (actionName === 'enableStop') {
                this.isEnableStop = false;
            } else if (actionName === 'disableStop') {
                this.isDisableStop = false;
            }
            if(this.restId) {
                this.$router.push({path: '/rest', name: 'RestStopList'});
            } else {
                this.$router.push({name: 'FastStopList',params:{backState:0}});
            }
        },
        clickAggregator() {
            this.activeAggregator = this.selectAggregatorsLocations.find(item => item.isSelect);
            if (this.activeAggregator.locations && Array.isArray(this.activeAggregator.locations)) {
                this.locationsList = this.activeAggregator.locations;
            }
        },
        selectItemHeader(itemHeader) {
            this.itemHeader = itemHeader;
            this.selectAggregatorsLocations.forEach(item => item.isSelect = item.id === this.itemHeader.id);
            this.clickAggregator();
        },
        clickSwitchItem(params) {
            if (this.activeAggregator.locations && Array.isArray(this.activeAggregator.locations)) {
                this.activeAggregator.locations.forEach(item => {
                    if (item.id === params.locationId) {
                        item.isSelect = params.state;
                    }
                })
            }
        },
        searchInputData(searchData) {
            if (searchData.length < 2 && searchData.length > 0) {
                return;
            }
            this.regTemplate = '(^|\\s)' + searchData;
            let regex = new RegExp(this.regTemplate, 'gi');
            if (searchData === '') {
                this.locationsList = this.activeAggregator.locations;
                return;
            }
            this.locationsList = this.activeAggregator.locations.filter(location => {
                regex = new RegExp(this.regTemplate, 'gi');
                if (location.uniq_id && regex.test(location.uniq_id)) {
                    return true;
                }
                regex = new RegExp(this.regTemplate, 'gi');
                if (location.title && regex.test(location.title)) {
                    return true;
                }

            });
        },
        clickBackArrow() {
            if(this.restId) {
                this.$router.push({name: 'ProductsStopList', params: {restId: this.restId, backState: 1}})
            } else {
                this.$router.push({name: 'FastStopList', params:{backState: 1}});
            }
        },
        enableStopProducts() {
            this.isEnableStop = true;
            const params = {
                selectLocations: this.selectLocations,
                action: 'add',
                actionName: 'enableStop',
            }
            this.$store.dispatch('aggregators/STOP_LIST_ACTION', params);
        },
        disableStopProducts() {
            this.isDisableStop = true;
            const params = {
                selectLocations: this.selectLocations,
                action: 'remove',
                actionName: 'disableStop'
            }
            this.$store.dispatch('aggregators/STOP_LIST_ACTION', params);
        },
    },
    computed: {
        ...mOrders([
            'posRestaurantsList',
        ]),
        ...mStopList([
            'selectAggregatorsLocationsRest',
            'selectProductsStopList',
            'selectAggregatorsLocationsAll'
        ]),
        colorSpinner() {
            return this.darkerColorHex('#F6673C', 40);
        },
        placeholderTextSearch() {
            return `${this.__t('O.SEARCH_LOCATION')}`;
        },
        restStopListTitle() {
            if (this.restStopList && this.restStopList.title) {
                return this.restStopList.title;
            }
            return '';
        },
        selectLocations() {
            let locations = [];
            this.selectAggregatorsLocations.forEach(aggr => {
                aggr.locations.forEach(location => {
                    if (location.isSelect) {
                        locations.push({id: location.id, title: location.title});
                    }
                })
            })
            return locations;
        }
    },
}
</script>
